import { RestRequest, } from '@Utils';
import { IPreviewVoiceRoute, ISharedVoiceRoute, } from 'atlas-shared';

export * from './abstract/voice_route.api.abstract';

export const terminateVoiceRoute = (id: IPreviewVoiceRoute['id']) => {
  return RestRequest.post<any, ISharedVoiceRoute>(`voice_route/${id}/terminate`, {}, { socket_id: global.socketId, });
};
